<div class="dashboard-shell" [class.dashboard-shell--menu-open]="mobileMenuOpen()">
  <aside
    #sidebar
    id="dashboard-sidebar"
    class="dashboard-sidebar"
    aria-label="Dashboard navigation"
    [attr.inert]="sidebarHidden() ? '' : null"
  >
    <a class="dashboard-brand" routerLink="/a/dashboard" aria-label="Savant dashboard">
      <img class="brand-symbol" src="/logo-icon.png" width="34" height="34" alt="" />
      <span class="brand-copy">Savant<small>PAYMENT GATEWAY</small></span>
    </a>

    <nav class="dashboard-nav" aria-label="Main navigation">
      <p class="nav-caption">WORKSPACE</p>
      <a class="nav-link" routerLink="/a/dashboard" routerLinkActive="nav-link--active" ariaCurrentWhenActive="page" [routerLinkActiveOptions]="{ exact: true }" (click)="closeMobileMenu()">
        <i class="ph ph-squares-four" aria-hidden="true"></i>
        <span>Overview</span>
      </a>
      <a class="nav-link" routerLink="/a/partners" routerLinkActive="nav-link--active" ariaCurrentWhenActive="page" (click)="closeMobileMenu()">
        <i class="ph ph-handshake" aria-hidden="true"></i>
        <span>Partners</span>
      </a>
      <a class="nav-link" routerLink="/a/statements" routerLinkActive="nav-link--active" ariaCurrentWhenActive="page" (click)="closeMobileMenu()">
        <i class="ph ph-file-text" aria-hidden="true"></i>
        <span>Statements</span>
      </a>
      <a class="nav-link" routerLink="/a/users" routerLinkActive="nav-link--active" ariaCurrentWhenActive="page" (click)="closeMobileMenu()">
        <i class="ph ph-users-three" aria-hidden="true"></i>
        <span>Users</span>
      </a>
      <p class="nav-caption nav-caption--secondary">RESOURCES</p>
      <a class="nav-link" routerLink="/a/help" routerLinkActive="nav-link--active" ariaCurrentWhenActive="page" (click)="closeMobileMenu()">
        <i class="ph ph-question" aria-hidden="true"></i>
        <span>Help &amp; support</span>
      </a>

      <p class="nav-caption nav-caption--secondary">YOUR DETAILS</p>
      <a class="nav-link" routerLink="/a/profile" routerLinkActive="nav-link--active" ariaCurrentWhenActive="page" [routerLinkActiveOptions]="{ exact: true }" (click)="closeMobileMenu()">
        <i class="ph ph-user-circle" aria-hidden="true"></i>
        <span>Your profile</span>
      </a>
    </nav>

    <div class="sidebar-bottom">
      <a class="sidebar-support" routerLink="/a/help" (click)="closeMobileMenu()">
        <span class="support-orbit" aria-hidden="true"><i class="ph ph-headset"></i></span>
        <span><strong>Need a hand?</strong><small>We’re here to help.</small></span>
        <i class="ph ph-arrow-up-right" aria-hidden="true"></i>
      </a>
      <div class="sidebar-user">
        <span class="user-avatar">{{ userInitials() }}</span>
        <span class="user-copy"><strong>{{ userName() }}</strong><small>{{ userEmail() }}</small></span>
        <button type="button" class="logout-button" aria-label="Sign out" title="Sign out" (click)="logout()">
          <i class="ph ph-sign-out" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </aside>

  <button
    class="sidebar-backdrop"
    type="button"
    aria-label="Close navigation"
    (click)="closeMobileMenu()"
    tabindex="-1"
  ></button>

  <div class="dashboard-main" [attr.inert]="contentHidden() ? '' : null">
    <header class="dashboard-topbar">
      <button
        #menuToggle
        class="mobile-menu-toggle"
        type="button"
        aria-controls="dashboard-sidebar"
        [attr.aria-label]="mobileMenuOpen() ? 'Close navigation menu' : 'Open navigation menu'"
        [attr.aria-expanded]="mobileMenuOpen()"
        (click)="toggleMobileMenu()"
      >
        <i class="ph ph-list" aria-hidden="true"></i>
      </button>
      <div class="breadcrumb">
        <span>Workspace</span>
        <i class="ph ph-caret-right" aria-hidden="true"></i>
        <strong>{{ pageTitle() }}</strong>
      </div>
      <div class="topbar-actions">
        <app-theme-toggle />
        <span class="topbar-date">{{ todayLabel() }}</span>
        <span class="topbar-divider"></span>
        <a class="topbar-profile" routerLink="/a/profile" aria-label="View your profile">
          <span class="topbar-avatar">{{ userInitials() }}</span>
          <span>{{ userName() }}</span>
          <i class="ph ph-caret-down" aria-hidden="true"></i>
        </a>
      </div>
    </header>

    <main class="dashboard-content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
